export default "__VITE_ASSET__9yZdvZ_w__"